module.exports = __webpack_public_path__ + "img/confetti-right.e0a98ee1.svg";